import { render, staticRenderFns } from "./ProductsByRowList.vue?vue&type=template&id=795f8300&scoped=true"
import script from "./ProductsByRowList.vue?vue&type=script&lang=ts"
export * from "./ProductsByRowList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795f8300",
  null
  
)

export default component.exports